import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { BARRIER_TYPE_OPTIONS } from '@/pages/instruments/new-instrument/constants/barrier-types'

export interface BarrierTypeCellEditorProps extends CustomCellEditorProps {}

export const BarrierTypeCellEditor: React.FC<BarrierTypeCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        setValue={(val) => {
          onValueChange(val !== null ? val : null)
          stopEditing()
        }}
        value={value?.toString()}
        options={BARRIER_TYPE_OPTIONS}
      />
    </div>
  )
}
